import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'Navigation' })((theme) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 20
    },
    side: {
        boxSizing: 'border-box',
        maxWidth: '50%',
        flex: '1 1 0',
        padding: 24,
        borderRadius: 24,
        backgroundColor: '#fff',
        backdropFilter: 'blur(40px)',
        textDecoration: 'none',
        color: '#232323',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 24,
        transition: 'all 0.2s',
        '@media (hover: hover)': {
            '&:hover': {
                backgroundColor: theme.palette.action.hover
            }
        }
    },
    _left: {
        textAlign: 'left',
        alignItems: 'flex-start',
        marginRight: 'auto'
    },
    _right: {
        textAlign: 'right',
        alignItems: 'flex-end',
        marginLeft: 'auto'
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2
    },
    title: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.26px'
    },
    date: {
        color: '#8E8E8E',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: '-0.24px'
    },
    arrow: {
        width: 24,
        height: 24,
        color: '#8E8E8E'
    },
    _rotated: {
        transform: 'rotate(180deg)'
    }
}));
